import React from "react";
import * as AuthProxy from "./security/AuthProxy";
import './css/Form.css';

type LoginProps = {
  onUrlChosen: (choice: AuthProxy.UserAuthorization) => void;
  auths: AuthProxy.UserAuthorization[];
};
export default class Form extends React.Component<LoginProps> {
  
  private selectedURL:string="";
  componentDidMount() { 
    window.process = { ...window.process }
}

handleSubmit= (e: any) => {
  e.preventDefault();
  const chosenAuth = this.props.auths.filter((it) => { return it.accountUrl.toLocaleLowerCase() == this.selectedURL.toLowerCase(); })[0];
  this.props.onUrlChosen(chosenAuth);
}

handleChange= (e:any) => {
  this.selectedURL=e.target.value;
}
  render(): React.ReactElement {
    return (
      <React.Fragment>
        <style>{`
        #form {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: nowrap; /* keep on one line */
          gap: 12px;
        }
        `}</style>
        <div id="formWrapper">
        <div id="infoBar"></div>
        <div><h2 id="userWarning">You are provisioned for multiple environments.</h2>
        <h3 id="userWarning"> Please select which environment you would like to go to:</h3>
        </div>
        <div id="formBox">
        <form onSubmit={this.handleSubmit} id="form">
        <select name="selectList" id="selectList" onChange={e => this.handleChange(e)}>
        <option value=""></option>
          {((this.props.auths).sort()).map(auth => {
            return (
            <option value={auth.accountUrl}>{auth.accountUrl}</option> 
          )
        })}
        </select>
        <input type="submit" id="submitBtn" />
        </form>
        </div></div>
      </React.Fragment>
    );
  }
}

